import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { api, getCachedUser, setCachedUser } from '../api';

export default function Profile({ onClose }) {
  const cached = getCachedUser();
  const [email, setEmail] = useState(cached ? cached.email || '' : '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    setMessage('');
  }, [email, currentPassword, newPassword, confirmPassword]);

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      const payload = { email: email || null };
      if (newPassword) {
        payload.currentPassword = currentPassword;
        payload.newPassword = newPassword;
        payload.confirmPassword = confirmPassword;
      }
      const updated = await api.updateProfile(payload);
      setCachedUser(updated);
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setMessage('Сохранено');
    } catch (e) {
      setMessage(e.message || 'Ошибка');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title="Профиль" onClose={onClose}>
      <div className="form-group">
        <label>Имя пользователя</label>
        <input value={cached ? cached.username : ''} disabled />
      </div>
      <div className="form-group">
        <label>E-mail (необязательно)</label>
        <input type="email" value={email} onChange={e => setEmail(e.target.value)} />
        <small className="muted">Если забудете данные для входа, напишите с этого адреса на <a href="mailto:webneo@list.ru">webneo@list.ru</a></small>
      </div>
      <div className="form-group" style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 12 }}>
        <label>Смена пароля</label>
        <input type="password" placeholder="Текущий пароль" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />
        <input type="password" placeholder="Новый пароль" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={{ marginTop: 8 }} />
        <input type="password" placeholder="Повторите новый пароль" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={{ marginTop: 8 }} />
      </div>
      <div className="form-group">
        <a className="support-link" href="mailto:webneo@list.ru">Написать в поддержку</a>
      </div>
      {message && <div className="form-note">{message}</div>}
      <div style={{ display: 'flex', gap: 8 }}>
        <button className="secondary" onClick={onClose}>Закрыть</button>
        <button onClick={handleSave} disabled={saving}>{saving ? 'Сохраняю...' : 'Сохранить'}</button>
      </div>
    </Modal>
  );
}
